import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '../targeting-settings-context';
import campaignColumnTemplate from './template/campaign-column.pug';

export default class ColumnCampaign extends CampaignuiBaseColumn {
  constructor({
    i18n,
    gridType,
  }) {
    super({
      name: 'CampaignName',
      type: 'string',
      property: _.compact([
        'Campaign/Id',
        'Campaign/Name',
        'Campaign/BaseCampaignName',
        'Campaign/CampaignType',
        'Campaign/Status',
      ]),
      sortable: 'Campaign/Name',
      title: 'ColumnName_Campaign',
      bodyClasses: ['col-CampaignName'],
      i18n,
    });

    this.i18n = i18n;
    this.gridType = gridType;
  }

  template({ value }) {
    if (_.isNull(value)) {
      return campaignColumnTemplate({
        name: '',
      });
    }

    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const isSmartCampaign = value.CampaignType === 'Smart';
    let link = '';

    if (isSmartCampaign) {
      link = value.Status === 'InProgress' ?
        `/campaign/Smart?cid=${cid}#/CreateCampaign/${value.cmpid}` :
        `/campaign/Smart?cid=${cid}#/campaign/${value.cmpid}`;
    } else {
      link = `/campaign/vnext/${this.gridType}?aid=${aid}&cid=${cid}&campaignId=${value.cmpid}`;
    }

    let ariaLabel = this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: value.name });
    let className = '';

    if (value.baseCampaignName) {
      ariaLabel = this.i18n.getString('Click to scope to experiment {{experimentName}}', { experimentName: value.name });
      className = 'experiment-name';
    }

    return campaignColumnTemplate({
      link,
      name: value.name,
      baseCampaignName: value.baseCampaignName,
      campaignId: value.cmpid,
      skipScopeNavigation: isSmartCampaign,
      ariaLabel,
      className,
    });
  }

  get property() {
    return {
      get: ({ Campaign }) => {
        if (Campaign) {
          return {
            cmpid: Campaign.Id,
            name: Campaign.Name,
            baseCampaignName: Campaign.BaseCampaignName,
            Status: Campaign.Status,
            CampaignType: Campaign.CampaignType,
          };
        }

        return null;
      },
      key: this.config.property,
    };
  }
}
